import { destroyCookie } from 'nookies'

/**
 * SC-11205: cookies da sessão sempre no path raiz.
 *
 * No navegador o `setCookie` do nookies não define `path`, então o cookie
 * herda a pasta da URL atual. A troca de conta (SC-10999) grava a sessão na
 * tela em que a pessoa está: feita em `/clientes/<uuid>`, o `nextauth.token`
 * ia para `path=/clientes`. Em `/clientes?tab=...` o navegador manda primeiro
 * o cookie de path mais longo e o `parseCookies` fica com ele, então o token
 * antigo (revogado pela troca) sombreava o novo: 401, logout e, a cada novo
 * login, o mesmo 401 de novo.
 */
export const SESSION_COOKIE_MAX_AGE = 60 * 60 * 24 * 6

export const SESSION_COOKIE_OPTIONS = {
  maxAge: SESSION_COOKIE_MAX_AGE,
  path: '/'
}

type CookieCtx = Parameters<typeof destroyCookie>[0]

const currentPathname = (ctx?: CookieCtx): string => {
  if (typeof window !== 'undefined') return window.location.pathname

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  const url = (ctx as any)?.resolvedUrl || (ctx as any)?.req?.url || '/'
  return String(url).split('?')[0]
}

/**
 * Paths em que um cookie desta URL pode ter sido gravado: a raiz e cada
 * prefixo do pathname (`/clientes/abc` vira `/`, `/clientes`, `/clientes/abc`).
 */
export const sessionCookiePaths = (pathname: string): string[] => {
  const paths = ['/']
  let current = ''

  pathname
    .split('/')
    .filter(Boolean)
    .forEach((segment) => {
      current = `${current}/${segment}`
      paths.push(current)
    })

  return paths
}

/**
 * Apaga o cookie na raiz e nos prefixos da URL atual. Remove também a cópia
 * deixada em path aninhado por versões anteriores, que sem isto só saía
 * limpando os cookies do navegador.
 */
export const destroySessionCookie = (ctx: CookieCtx, name: string) => {
  sessionCookiePaths(currentPathname(ctx)).forEach((path) => {
    destroyCookie(ctx, name, { path })
  })
}
